<div style="display: inline;block-size: 10%;"> 
  
  <div class="col-md-12" style="padding: 16px;">
    <div class="row">
      <div class="col-md-3" style="padding: 0px;">
        <h2 class="ng-binding" style="font-size: 30px;">Production Planning</h2>
      </div>
        <!-- <div class="col-md-9"> -->
          <div class="col-md-9" style="text-align: right; padding: 0px;">   
         <span _ngcontent-ceh-c1="" class="btn btn-orange" style="line-height: 33px !important; margin-right: 2%;
            padding: 5px 10px; font-size: 13px !important;color:#fff; border: 1px solid #e88421;  background:#e88421;  border-radius: 25px;padding: 0px 15px;">
         <span style="margin-right: 5px;"><i  
             aria-hidden="true" class="zmdi zmdi-plus"
            style="font-size: 16px;position: relative;top: 1px;"></i>
            </span><span >Create Job</span></span>
 
           <span class="btn btn-yellow" style="line-height: 33px !important; margin-right: 2%;
            padding: 5px 10px; font-size: 13px !important;color:#fff; background: #E1A730; border-radius: 25px;padding: 0px 15px;">
             <span style="margin-right: 5px;"><i 
              aria-hidden="true" class="zmdi zmdi-plus"
               style="font-size: 16px;position: relative;top: 1px;"></i>
                </span><span >Create SO</span></span>
   
             <span class="btn btn-green" style="line-height: 33px !important; margin-right: 2%;
             padding: 5px 10px; font-size: 13px !important;color:#fff;  background:#4caf50;  border-radius: 25px;padding: 0px 15px;">
              <span  style="margin-right: 5px;"><i 
                aria-hidden="true" class="zmdi zmdi-plus"
                 style="font-size: 16px;position: relative;top: 1px;"></i>
                  </span><span>Create PO</span></span>    

                  <span class="btn btn-teal fntSz" style="line-height: 33px !important; margin-right: 2%;
                  padding: 5px 10px; font-size: 13px !important;color:#fff; background: #009688;  border-radius: 25px;padding: 0px 15px;">
                   <span  style="margin-right: 5px;"><i 
                     aria-hidden="true" class="zmdi zmdi-plus"
                      style="font-size: 16px;position: relative;top: 1px;"></i>
                       </span><span>Plan Purchase</span></span>    

                     <span class="btn-blue" style="margin-right: 1.5%;" (click)="exportToExcel()">
                      <i aria-hidden="true" class="fa fa-file-excel-o" title="Export to Excel" style="font-size: 16px;
                      cursor: pointer; line-height: 20px; text-decoration: none;
                       position: relative; padding: 5px 4px;"></i></span>

                     <span  (click)="refresh()" _ngcontent-buo-c0="" class="btn lableBtnDarkBlue menubottomBtn" 
                     style=" padding: 7px 13px !important; border-radius: 50%; vertical-align: middle; 
                     font-size: 13px; margin: 0px 0px; background: #1f628e33 !important; 
                     color: #1f628e " title="Refresh"><i _ngcontent-buo-c0="" 
                      class="fa fa-refresh"
                       style="display: inline-block;color:#1f628e !important"></i></span>

                       <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px; font-size: 15px; margin-left: 10px;" (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                    </span>
             <!-- </div>     -->
            </div>
        </div>    
      </div>  
    </div> 
<div class="row" data-ng-show="filter.divShow" >
  <div class="col-md-4" style="display: inline-block;">
    <input class="form-control wid100" list="cgstOut" placeholder="Select category">
                <datalist id="cgstOut">
                  <option  value="LedgerName">LedgerName</option>
                  <option  value="item">item</option>
                  <option  value="category">category</option>
                  <option  value="room">room</option>
                  <option  value="food">food</option>
                </datalist>
  </div>
    <!-- Enter number of days-->
    <div class="col-md-2" style="display: inline-block; padding: 4px;">
        <label>Next :</label>
        <input  numbers_only="" style="width: 45px; margin-left: 2%; border-bottom: 1px solid #BCC2C9 !important; border-top: none; border-left: none; border-right: none; " class="days" type="text">
        <label style="margin-left: 0.5%;">days</label>
  </div> 
</div>

<div class="wrapper" style=" overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"  #pprtable>
    <table mat-table [dataSource]="dataSource">
     
      <ng-container matColumnDef="product">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Product</label>
        </th>
        <td mat-cell *matCellDef="let element"> {{element.product}} </td>
      </ng-container>
      <ng-container matColumnDef="code">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label> Code</label>
        </th>
        <td mat-cell *matCellDef="let element">  {{element.code}}  </td>
      </ng-container>
    
      <ng-container matColumnDef="orders">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Orders</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">  {{element.orders}} </td>
      </ng-container>

      <ng-container matColumnDef="stocks">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Stocks</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.stocks}} </td>
      </ng-container>

      <ng-container matColumnDef="incoming">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>Incoming</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.incoming}} </td>
      </ng-container>

      <ng-container matColumnDef="WIP">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>WIP</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.WIP}} </td>
      </ng-container>

      <ng-container matColumnDef="unplanned">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Unplanned</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.unplanned}} </td>
      </ng-container>

      <ng-container matColumnDef="unit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label>Unit</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.unit}} </td>
      </ng-container>

      <ng-container matColumnDef="leadtime">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef >
          <label>Leadtime</label>
        </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">{{element.leadtime}} {{element.leadtime == 1 ? 'day' : 'days'}} </td>
      </ng-container>
    
      <ng-container matColumnDef="edit">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element" style="width: 10px;">
          <div class="lableBtnOrange ng-scope" style="border-radius: 50%;">
            <i class="fa fa-pencil" aria-hidden="true" ng-click="openCustomerEnrtyModal(net)"></i>
        </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th class="header header-Table" mat-header-cell *matHeaderCellDef>
          <label> </label>
        </th>
        <td mat-cell *matCellDef="let element" style="width: 10px;"> 
          <div class="lableBtnGray inLneBlk" style="border-radius: 50%;">
            <i class="fa fa-trash" aria-hidden="true" ng-click="openCustomerEnrtyModal(net)"></i>
        </div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
   <!-- Angular 8 pagination -->
   <mat-paginator
        [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
   </mat-paginator>
</div>
  
<!-- <button mat-raised-button color="primary" (click)="ExportTOExcel()">Export as Excel</button> -->